module.exports = __webpack_public_path__ + "img/on.4ea6f9e0.png";